import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import "./style.css";

const menus = [
  {
    id: 1,
    title: "Home",
    link: "/",
  },

  {
    id: 2,
    title: "About",
    link: "/about",
  },

  {
    id: 6,
    title: "Service",
    link: "/service",
  },

  //   {
  //     id: 3,
  //     title: "Pages",
  //     link: "/",
  //     submenu: [
  //       {
  //         id: 31,
  //         title: "Project",
  //         link: "/project",
  //       },
  //       {
  //         id: 32,
  //         title: "Project single",
  //         link: "/project-single/1",
  //       },
  //       {
  //         id: 322,
  //         title: "Team Single",
  //         link: "/team-single/1",
  //       },
  //       {
  //         id: 332,
  //         title: "Appointment",
  //         link: "/appointment",
  //       },
  //       {
  //         id: 333,
  //         title: "Terms & Conditions",
  //         link: "/terms",
  //       },
  //       {
  //         id: 334,
  //         title: "Testimonial",
  //         link: "/testimonial",
  //       },
  //       {
  //         id: 33,
  //         title: "Pricing",
  //         link: "/pricing",
  //       },
  //       {
  //         id: 34,
  //         title: "404 Error",
  //         link: "/404",
  //       },
  //       {
  //         id: 35,
  //         title: "Login",
  //         link: "/login",
  //       },
  //       {
  //         id: 36,
  //         title: "Register",
  //         link: "/register",
  //       },
  //     ],
  //   },

  //   {
  //     id: 5,
  //     title: "Blog",
  //     link: "/blog",
  //     submenu: [
  //       {
  //         id: 51,
  //         title: "Blog",
  //         link: "/blog",
  //       },
  //       {
  //         id: 52,
  //         title: "Blog Left sidebar",
  //         link: "/blog-left",
  //       },
  //       {
  //         id: 53,
  //         title: "Blog full width",
  //         link: "/blog-fullwidth",
  //       },
  //       {
  //         id: 54,
  //         title: "Blog single",
  //         link: "/blog-single/1",
  //       },
  //       {
  //         id: 55,
  //         title: "Blog single Left sidebar",
  //         link: "/blog-single-left-sidebar/1",
  //       },
  //       {
  //         id: 56,
  //         title: "Blog single Left sidebar",
  //         link: "/blog-single-fullwidth/1",
  //       },
  //     ],
  //   },
  {
    id: 88,
    title: "Contact",
    link: "/contact",
  },
];

const MobileMenu = () => {
  const [openId, setOpenId] = useState(0);
  const [menuActive, setMenuState] = useState(false);

  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
        <div className="menu-close">
          <div className="clox" onClick={() => setMenuState(!menuActive)}>
            <i className="ti-close"></i>
          </div>
        </div>

        <ul className="responsivemenu">
          {menus.map((item, mn) => {
            return (
              <ListItem
                className={item.id === openId ? "active" : null}
                key={mn}
              >
                {item.submenu ? (
                  <Fragment>
                    <p
                      onClick={() =>
                        setOpenId(item.id === openId ? 0 : item.id)
                      }
                    >
                      {item.title}
                      <i
                        className={
                          item.id === openId
                            ? "fa fa-angle-up"
                            : "fa fa-angle-down"
                        }
                      ></i>
                    </p>
                    <Collapse
                      in={item.id === openId}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List className="subMenu">
                        <Fragment>
                          {item.submenu.map((submenu, i) => {
                            return (
                              <ListItem key={i}>
                                <NavLink
                                  onClick={ClickHandler}
                                  exact
                                  activeClassName="active"
                                  to={submenu.link}
                                >
                                  {submenu.title}
                                </NavLink>
                              </ListItem>
                            );
                          })}
                        </Fragment>
                      </List>
                    </Collapse>
                  </Fragment>
                ) : (
                  <NavLink exact activeClassName="active" to={item.link}>
                    {item.title}
                  </NavLink>
                )}
              </ListItem>
            );
          })}
        </ul>
      </div>

      <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  );
};

export default MobileMenu;
